/**
 * B.S.C. Laboratories — sticky mobile purchase bar.
 * Shows once the main product form scrolls out of view (mobile/tablet only; hidden on desktop via CSS).
 * Mirrors the selected dose, quantity, price, and Add to Cart / Sold Out state from bsc-dose-selector.js.
 */
(function () {
  var bar = document.querySelector('[data-bsc-sticky-bar]');
  if (!bar) return;

  var formId = bar.getAttribute('data-bsc-target-form');
  var form = document.getElementById(formId);
  var sentinel = document.querySelector('[data-bsc-sticky-sentinel="' + formId + '"]');

  var doseEl = bar.querySelector('[data-bsc-sticky-dose]');
  var priceEl = bar.querySelector('[data-bsc-sticky-price]');
  var btn = bar.querySelector('[data-bsc-sticky-btn]');

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  document.addEventListener('bsc:variant-change', function (e) {
    if (!e.detail || e.detail.formId !== formId) return;
    var variant = e.detail.variant;
    if (doseEl) doseEl.textContent = variant.option1 || variant.title;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (btn) {
      if (variant.available) {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      } else {
        btn.disabled = true;
        btn.textContent = 'Sold Out';
      }
    }
  });

  if (btn) {
    btn.addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('bsc:sticky-add-to-cart', { detail: { formId: formId } }));
    });
  }

  if (sentinel && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  }
})();
